import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router';
import { ROUTES } from '../constants/RoutingConstants';
import { AvatarTwoTones } from './UI/SVGAssets/SVGAssets';
import { Bold } from './UI/TextFormatters';
import version from '../version.json';
import { useEffect, useState } from 'react';
import GeneralAPI from '../services/GeneralAPI';

const useStyles = makeStyles(theme => ({
  userWrapper: ({ readOnly }) => ({
    cursor: readOnly ? 'unset' : 'pointer',
    display: 'flex',
    justifyContent: 'center',
    columnGap: '.5em',
  }),
  userAvatar: ({ readOnly }) => ({
    cursor: readOnly ? 'default' : 'pointer',
    padding: 0,
    boxShadow: `inset 0px 0px 10px 0px ${theme.palette.primary.main}`,
  }),
  userInfoWrapper: ({ readOnly }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: '.8em',
    transition: '300ms ease-in-out',
    '&:hover': {
      color: readOnly ? 'unset' : theme.palette.primary.main,
    },
  }),
}));

const MyAccountAvatar = ({ userInfo, readOnly, setOpenDrawer, setScreenTitle }) => {
  const history = useHistory();
  const classes = useStyles({ readOnly: readOnly });
  const showVersion = userInfo.userName === 'vid_vs\\ext.arielg';
  const [backend, setBackend] = useState('');

  useEffect(() => {
    if (readOnly && showVersion) {
      GeneralAPI.getVersion().then(res => setBackend(res.version))
    }
  }, []);

  const showMyAccount = () => {
    setOpenDrawer(false);
    history.push(ROUTES.MY_ACCOUNT);
    setScreenTitle('');
  };

  const showTooltip = () => {
    let title = '';
    if (!readOnly) {
      title = 'Mi cuenta';
    } else if (showVersion){
      /*title = <div>
        <div>Frontend V{version.major}.{version.minor}.{version.revision}</div>
        <div>Frontend V{version.fecha}</div>
        <div>Backend V{backend}</div>        
      </div>;*/
      title = <div>
        <div>Frontend V{version.fecha}</div>
        <div>Backend V{backend}</div>        
      </div>;      
    }
    return title;
  }

  const titleRole = userInfo.role.includes("CHATARRERO") ? "CHATARRERO" : userInfo.role;

  return (
    <div className={classes.userWrapper} onClick={!readOnly ? showMyAccount : undefined}>
      <Tooltip title={showTooltip()} enterDelay={1000}>
        <IconButton className={classes.userAvatar} onClick={!readOnly ? showMyAccount : undefined}>
          <AvatarTwoTones />
        </IconButton>
      </Tooltip>
      <div className={classes.userInfoWrapper}>
        <div>{userInfo.name}</div>
        <div>
          <Bold>{titleRole.toTitleCase()}</Bold>
        </div>
      </div>
    </div>
  );
};

export default MyAccountAvatar;
